// src/store/slices/testimonialSlice.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createGenericSlice } from './genericSliceFactory';
import { apiMethods } from '../../services/api';
import type { Testimonial, ApiResponse } from '@/types';

const testimonialSlice = createGenericSlice<Testimonial>({
    name: 'testimonials',
    endpoint: '/testimonials',
});

export const {
    setCurrentItem: setCurrentTestimonial,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = testimonialSlice.actions;

export const {
    create: createTestimonial,
    fetchActive: fetchActiveTestimonials,
} = testimonialSlice.thunks;

// ── Public endpoints ──────────────────────────────────────────────────────────

export const fetchTestimonialStats = createAsyncThunk(
    'testimonials/fetchStats',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiMethods.get<ApiResponse<Record<string, any>>>(
                '/testimonials/stats'
            );
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch testimonial stats');
        }
    }
);

export default testimonialSlice.reducer;
